
export class DObjetoDocumentoFirmaVista {  

    numeroDoc: number;
    mensajeDoc: string;

    constructor(
        numeroDoc: number,
        mensajeDoc: string
    ){
        this.numeroDoc = numeroDoc;
        this.mensajeDoc = mensajeDoc;
    }
    
}


// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/to/dobjeto-documento-firma-vista.ts